import {BASE_URL} from "./baseURL";

export const CreateOrUpdatePlan = async ({ Data }) => {
  debugger
  const url = `${BASE_URL}/Sbdrive/CreateOrUpdatePlan`;

  const data = {
    PolicyNumber: Data.PolicyNumber,
    driver: Data.driver,
    PlateType: Data.PlateType
  };

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    return response.json();
  }

  return response.json();
};

export const sendToken = async (phone) => {
  debugger
  const url = `${BASE_URL}/account/sendtoken`;

  const data = {
    mobileNumber: phone
  };

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error("Failed");
  }

  return response.json();
};

export const verifytoken = async (pinId, otp) => {
  debugger
  const url = `${BASE_URL}/account/verifytoken`;

  const data = {
    pinId: pinId,
    pin: otp,

  };

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    return response.json();
  }

  return response.json();
};